import React from 'react';
import { Popover } from 'antd';
import {
  ModifyOption, OptionGroup, ModifyAmount, Volume,
} from './styles';
import { VOLUME_MODIFIERS } from '../../constants/dataPages.constants';

const Modifier = ({
  volume, state: { modifier }, onChange,
}) => (
  <div>
    <OptionGroup
      value={modifier}
      onChange={({ target: { value } }) => onChange({ volume, modifier: value })}
    >
      {
        Object.keys(VOLUME_MODIFIERS)
          .map(value => (
            <div key={value}>
              <ModifyOption
                value={value}
              >
                {VOLUME_MODIFIERS[value].name}
              </ModifyOption>
              {
                (modifier === value && VOLUME_MODIFIERS[modifier].required)
                  && (
                    <ModifyAmount
                      max={VOLUME_MODIFIERS[modifier].max(volume)}
                      size="small"
                      min={0}
                      onBlur={am => onChange({ volume, amount: am, modifier })}
                    />
                  )
              }
            </div>
          ))
      }
    </OptionGroup>
  </div>
);

// Antd Popover in IE11 can't be disabled in a typical method.
const ModifierWrapper = ({ disabled, ...rest }) => disabled
  ? <span {...rest} /> : <Popover {...rest} />;

class VolumeEditor extends React.Component {
  state = {
    // visible: false,
    modifier: Object.keys(VOLUME_MODIFIERS)[0],
    amount: '',
  }

  // The UI and select behavior is revamped to deal with IE11 handles badly with
  // keypress in antd InputNumber with onChange. Onblur is used, and OK button
  // removed to use the default antd click trigger.
  onSelect = ({ modifier, amount = 0 }) => {
    let value = (amount && amount.target) ? parseInt(amount.target.value, 10) : amount;
    const newObject = { modifier };

    if (Number.isNaN(value)) {
      value = 0;
    }

    if (value) {
      newObject.amount = value;
    }

    this.setState(newObject, () => {
      const {
        volume, day, area, onEdit,
      } = this.props;

      onEdit({
        area, day, volume, modifier, amount: value,
      });
    });
  }

  render() {
    const {
      volume, disabled,
    } = this.props;
    const { modifier, amount } = this.state;

    return (
      <ModifierWrapper
        title="Modify Amount"
        trigger="click"
        placement="leftTop"
        disabled={disabled}
        content={(
          <Modifier
            state={{ modifier, amount }}
            volume={volume}
            onChange={this.onSelect}
          />
        )}
      >
        <Volume disabled={disabled}>
          {volume.toLocaleString()}
        </Volume>
      </ModifierWrapper>
    );
  }
}

export default VolumeEditor;
